"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceFormat = void 0;
var invoiceFormatUrl = '/delivery/invoice-format';
exports.invoiceFormat = function (axios) {
    return {
        getInvoiceFormat: function (getInvoiceFormatRequest) {
            return axios.get(invoiceFormatUrl, getInvoiceFormatRequest);
        },
        putInvoiceFormat: function (putInvoiceFormatRequest) {
            return axios.put(invoiceFormatUrl, putInvoiceFormatRequest.data);
        },
        getInvoiceFormatInit: function (getInvoiceFormatInitRequest) {
            return axios.get(invoiceFormatUrl + "/init", getInvoiceFormatInitRequest);
        }
    };
};
